import { useState, useMemo, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import { cancelTokenSelector } from '../redux/selectors/selectors';
import { convertListToMap } from '../util/UtilFunctions';
import { BLOCK_LIST_PROP_NAME_MAP } from '../constants/general';
import { GUARDIAN_API_URL } from '../constants/config';
import * as browserStorage from '../misc/BrowserStorageManager';

// type = 'ip' | 'referer'
function useBlockListFetcher({ type }) {
   const streamGuardToken = browserStorage.getJwtToken();
   const cancelToken = useSelector(cancelTokenSelector);

   const httpHeader = useMemo(() => ({ 'X-BINTU-TOKEN': streamGuardToken, 'Content-Type': 'application/json' }), [
      streamGuardToken,
   ]);

   const [blockedMap, setBlockedMap] = useState();
   const [fetchError, setFetchError] = useState(false);

   const isMountedRef = useRef(true);
   useEffect(() => {
      isMountedRef.current = true;
      return () => {
         isMountedRef.current = false;
      };
   }, []);

   const { mutate: fetchBlockList } = useMutation(
      () =>
         axios
            .get(`${GUARDIAN_API_URL}/${type}`, {
               headers: httpHeader,
               cancelToken: cancelToken.token,
               withCredentials: false,
            })
            .then((res) => convertListToMap(res.data.data.denied, BLOCK_LIST_PROP_NAME_MAP[type], true)),
      {
         onMutate: () => {
            if (isMountedRef.current) setFetchError(false);
         },
         onSuccess: (data) => {
            if (isMountedRef.current) setBlockedMap(data);
         },
         onError: (err) => {
            if (!isMountedRef.current || err instanceof axios.Cancel) return;
            setBlockedMap(undefined);
            setFetchError(true);
         },
      },
   );

   return { fetchBlockList, blockedMap, fetchError };
}

export default useBlockListFetcher;
